/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ at: NonNullable<unknown> }} Ebr_Conn_UpdatedInputs */

const cs_ebr_conn_updated = /** @type {(inputs: Ebr_Conn_UpdatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`uloženo ${i?.at}`)
};

const en_ebr_conn_updated = /** @type {(inputs: Ebr_Conn_UpdatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`saved ${i?.at}`)
};

/**
* | output |
* | --- |
* | "saved {at}" |
*
* @param {Ebr_Conn_UpdatedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_conn_updated = /** @type {((inputs: Ebr_Conn_UpdatedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Conn_UpdatedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_conn_updated(inputs)
	return cs_ebr_conn_updated(inputs)
});